import style from './Notificator.module.scss'

interface IProps {
    companyName: string
}

export const Notificator = (props: IProps) => (
    <div className={style.container}>
        <span>{props.companyName}</span>
    </div>
)
